import { ViewType } from '@this+that/models';

import { TabId } from '../../components/InboxTabsFilter/constants';
import { APP_PAGES } from '../../routes/constants';
import { PageType } from '../../utils/pageContext';

export const DEFAULT_VIEWTYPE: ViewType = 'PRIMARY';

export const URL_PARAMS = {
  TAB: 'tab',
  DOBOX_ID: 'doboxId',
  TASK_GROUP_ID: 'taskGroupId',
  TEAM_ID: 'teamId',
  DOBOX_TAB: 'doboxTab',
  RUN_VIEW: 'runView',
  MONITOR: 'monitor',
} as const;

export const DOBOX_TAB_PARAM_VALUE = {
  TASKS: 'tasks',
  RECURRENCES: 'recurrences',
  WATCHING: 'watching',
} as const;

/** Values for `URL_PARAMS.RUN_VIEW` — set by `useOpenDoBoxRunView`/the header's
 *  AgentStatusChip so a reload or a shared link reopens the same run view (see
 *  `InboxEntryDetailsModal`'s consuming effect). */
export const DOBOX_RUN_VIEW_PARAM_VALUE = {
  OPEN: '1',
  FULL_SCREEN: 'full',
} as const;

export const RESOLVED_FILTER = {
  UNRESOLVED: 'unresolved',
  RESOLVED: 'resolved',
} as const;

export const TAB_TO_VIEWTYPE_MAP: Record<TabId, ViewType> = {
  inbox: 'PRIMARY',
  promotions: 'PROMOTIONS',
  social: 'SOCIAL',
  updates: 'UPDATES',
  forums: 'FORUMS',
};

export const PAGE_TYPE_TO_VIEWTYPE_MAP: Record<PageType, ViewType | undefined> =
  {
    [PageType.INBOX]: 'PRIMARY',
    [PageType.SPAM]: 'SPAM',
    [PageType.TRASH]: 'TRASH',
    [PageType.SENT]: 'SENT',
    [PageType.DRAFT]: 'DRAFT',
    [PageType.ALL]: 'ALL_EMAILS',
    [PageType.DOBOX]: undefined,
    [PageType.ARCHIVE]: undefined,
    [PageType.LABELS]: undefined,
    [PageType.SNOOZED]: undefined,
    [PageType.UNKNOWN]: undefined,
  };

export const PAGE_PATH_TO_VIEWTYPE_MAP: Record<string, ViewType | undefined> = {
  [APP_PAGES.INBOX]: undefined,
  [APP_PAGES.INBOX_DRAFT]: 'DRAFT',
  [APP_PAGES.INBOX_SENT]: 'SENT',
  [APP_PAGES.INBOX_SPAM]: 'SPAM',
  [APP_PAGES.INBOX_TRASH]: 'TRASH',
  [APP_PAGES.INBOX_ALL]: 'ALL_EMAILS',
  [APP_PAGES.INBOX_LABELS]: undefined,
  [APP_PAGES.SLACK_INBOX_OVERVIEW]: undefined,
};
